import { Component, ElementRef, Input, NgZone, OnInit, OnChanges, ViewChild, ViewContainerRef } from '@angular/core';
import { FormControl } from '@angular/forms';
import { MdDialog, MdDialogConfig, MdDialogRef } from '@angular/material';

import { Observable } from 'rxjs/Observable';
import { MapsAPILoader } from '@agm/core';

import { ApplicationValue } from 'app/services/warmup/application-type.model';
import { ApplicationTypeConstants } from 'app/services/warmup/warmup.service';
import { WarmUpService } from 'app/services/warmup/warmup.service';

import { MessageService } from 'app/services/messages.service';
import { SnackBarService } from 'app/services/snackbar.service';
import { ConfirmationService } from 'primeng/primeng';

import { TrackingService } from 'app/shared/services/tracking/google-analytics-events.service';
import { TrackingConstants } from 'app/shared/services/tracking/tracking-constants.service';

import { AddAddressComponent } from 'app/entities/details/addressinformation/addaddress/add-address.component';
import { AddressInformationService } from 'app/entities/details/addressinformation/address-information.service';

import { Address } from 'app/shared/models/address.model';
import { EntityType, EntityIdDetails } from 'app/shared/models/entity-id-details.model';

@Component({
    selector: 'address-information',
    templateUrl: './address-information.component.html',
    providers: [ConfirmationService],
    styleUrls: ['./address-information.component.css']
})

/**
 * Component for Address information.
 */
export class AddressInformationComponent implements OnInit, OnChanges {
    @Input() entityIdDetails: EntityIdDetails;

    public id: number;

    add = 'Add';
    edit = 'Edit';
    private zoom: number;
    selectedAddress: Address;

    @ViewChild('search')
    public searchElementRef: ElementRef;

    dialogRef: MdDialogRef<any>;
    addressTypes: ApplicationValue[];
    addresses: Array<Address>;
    addressByTypeMapping = new Map<String, Array<Address>>();
    responseAddressTypes = new Array<String>();

    constructor(
        public dialog: MdDialog,
        private addressService: AddressInformationService,
        private warmUpService: WarmUpService,
        private viewContainerRef: ViewContainerRef,
        private trackingService: TrackingService,
        private snackBarService: SnackBarService,
        private confirmationService: ConfirmationService
    ) { }

    ngOnInit() {
        this.setUpAddressTypes();
        this.zoom = 13;
    }

    ngOnChanges() {
      if (this.entityIdDetails && this.entityIdDetails.entityId) {
        this.id = (this.entityIdDetails.entityType === EntityType.PERSON)
              ? this.entityIdDetails.personId
              : this.entityIdDetails.orgId;

          this.loadAddressInfo(this.id);
        }
    }

    // Load Addresses information.
    loadAddressInfo(id: number) {
        this.addresses = [];
        this.responseAddressTypes = [];
        this.addressService.loadAddressInformation(this.id, this.entityIdDetails.entityType)
        .subscribe(response => {
            this.addressByTypeMapping = new Map<String, Array<Address>>();
            this.addresses = response;
            this.addresses.forEach(address => {
                const addressTypeName = this.getAddressTypeName(Number(address.addressType));
                const addresses = this.addressByTypeMapping.get(addressTypeName)
                    ? this.addressByTypeMapping.get(addressTypeName)
                    : new Array();
                addresses.push(address);
                this.addressByTypeMapping.set(addressTypeName, addresses);
                this.responseAddressTypes = Array.from(this.addressByTypeMapping.keys());
            });
        });
    }

    // Set up address types.
    setUpAddressTypes() {
        const addressTypes =
            this.warmUpService.getApplicationValue(ApplicationTypeConstants.ADDRESS_TYPE);
        if (addressTypes instanceof Observable) {
            addressTypes.subscribe(
                response => {
                    this.warmUpService.setApplicationTypeInLS(response);
                    this.addressTypes = response.values;
                }
            );
        } else {
            this.addressTypes = addressTypes;
        }
    }

    // Get address type name
    getAddressTypeName(addressId: number) {
        if (this.addressTypes) {
            return this.addressTypes.find(addressType => addressType.id === addressId).name;
        }
        return '';
    }

    // Get all addreses to be displayed on the screen.
    getAddresses(addressType: string) {
        if (this.addressByTypeMapping) {
            return this.addressByTypeMapping.get(addressType);
        }
    }

    // Open Add New Address Dialog Box.
    openAddAddressDialog(action: string) {
        const config = new MdDialogConfig();
        config.disableClose = true;
        config.viewContainerRef = this.viewContainerRef;

        this.dialogRef = this.dialog.open(AddAddressComponent, config);
        this.dialogRef.componentInstance.selectedAddress = this.selectedAddress;
        this.dialogRef.componentInstance.entityId = this.entityIdDetails.entityId;
        this.dialogRef.componentInstance.action = action;
        this.dialogRef.afterClosed().subscribe(result => {
            this.dialogRef = null;
            this.selectedAddress = null;
            if (result) {
                this.loadAddressInfo(this.id);
            }
        });
    }

    // Open Update Existing Address Dialog Box.
    openEditAddressDialog(value: Address): void {
        this.selectedAddress = value;
        this.openAddAddressDialog(this.edit);
    }

    // Delete selected address record.
    deleteAddressRecord(selectedAddressRecord: Address, flagConfirmDelete?: boolean): void {
        if(flagConfirmDelete) {
            this.confirmationService.confirm({
                message: "Are you sure you want to delete the selected address?",
                accept: () => {
                    const addressRecord = new Address();
                    addressRecord.id = selectedAddressRecord.id;
                    addressRecord.entityId = selectedAddressRecord.entityId;
                    this.addressService.deleteAddressRecord(addressRecord)
                      .subscribe(response => {
                        if (response.flagResult) {
                          this.addresses.splice(this.addresses.indexOf(selectedAddressRecord), 1);
                        }
                        this.trackingService
                          .emitEvent(
                          TrackingConstants.ADDRESS_CARD_MANAGEMENT,
                          TrackingConstants.DELETE_ADDRESS,
                          TrackingConstants.SUCCESS, 1);
                        this.callSnackBarService(response);
                        this.loadAddressInfo(this.id);
                      }, err => {
                        this.trackingService
                          .emitEvent(
                          TrackingConstants.ADDRESS_CARD_MANAGEMENT,
                          TrackingConstants.DELETE_ADDRESS,
                          TrackingConstants.FAILURE, 0);
                        this.callSnackBarService(err);
                      });
                }
            });
        }
    }

    callSnackBarService(response: any) {
        this.snackBarService
            .showStatus(response,
            MessageService.ADDRESS_DELETE_SUCCESS,
            MessageService.ADDRESS_DELETE_FAILURE);
    }
}



// WEBPACK FOOTER //
// ./src/app/entities/details/addressinformation/address-information.component.ts